import $ from 'jquery';

$('.show-password').on('click', ev => {
    const $toggle = $(ev.currentTarget);
    const $parent = $toggle.closest('.password-wrap');
    if ($parent.length === 0) {
        return;
    }
    $parent.find('input').attr('type', 'text');
    $parent.find('.hide-password').removeClass('d-none');
    $toggle.addClass('d-none');
});

$('.hide-password').on('click', ev => {
    const $toggle = $(ev.currentTarget);
    const $parent = $toggle.closest('.password-wrap');
    if ($parent.length === 0) {
        return;
    }
    $parent.find('input').attr('type', 'password');
    $parent.find('.show-password').removeClass('d-none');
    $toggle.addClass('d-none');
});
